import { TextFieldStyles } from "./textField.styles";

const TextField = ({
  onChange,
  value,
  error,
  touched,
  onBlur,
  placeholder,
  id,
  type = "text",
  pattern,
  name
}) => {
  return (
    <TextFieldStyles>
      <input
        autoComplete="off"
        id={id}
        name={name}
        type={type}
        className={`input ${touched && error && "error"}`}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        placeholder={placeholder}
        pattern={pattern}
      />
      <p className="errorMessage">{touched && error && error}</p>
    </TextFieldStyles>
  );
};

export default TextField;
